import { UseQueryOptions } from '@tanstack/react-query';

import useQuery from 'hooks/useQuery';
import { CuredApiPaths } from 'models/enums';

import QueryKeys from './keys';

type UseTemplateHTMLParams = {
    templateId: number;
    reactQueryOptions?: UseQueryOptions<string, Error>;
};

const useTemplateHTML = ({ templateId, reactQueryOptions }: UseTemplateHTMLParams) =>
    useQuery<string>(
        QueryKeys.TEMPLATE_HTML(templateId),
        `${CuredApiPaths.TEMPLATES}/${templateId}/html`,
        reactQueryOptions
    );

export default useTemplateHTML;
